import "../../pages/products/productDetails.css";
import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Footer from "../footer/footer";
import CustomNavbar from "../products/productnavbar";
import { Tabs, Tab, Spinner } from "@nextui-org/react";
import RevealBlurFX from "../../../components/Effect/RevealFX";
import { BASEURL } from "../../../constant/constant";

function SearchDetails() {
    // const { categoryId, subCategoryId, productItemId } = useParams();
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [selectedTab, setSelectedTab] = useState(0);


    const location=useLocation();
    const {categoryId,subCategoryId,productItemId}=location.state || {};

    
    
    
    useEffect(() => {
        if (categoryId && subCategoryId && productItemId) {
            fetchProducts(categoryId, subCategoryId,productItemId);
        }
        // console.log(`this is all id's get by product page====> CID${categoryId},SID${subCategoryId},PID${productItemId}`);
    }, [categoryId, subCategoryId, productItemId]);
    
    const fetchProducts = async (categoryId, subCategoryId) => {
        setLoading(true);
        try {
            const response = await fetch(`${BASEURL}/api/product/getProducts?category_id=${categoryId}&sub_category_id=${subCategoryId}&productitemid${productItemId}&published_only=true`);
            const data = await response.json();

            if (data.products && Array.isArray(data.products)) {
                setProducts(data.products);

                const selectedIndex = data.products.findIndex(product => product.productItemId.toString() === productItemId);
                setSelectedTab(selectedIndex !== -1 ? selectedIndex : 0);
            } else {
                setProducts([]);
                setSelectedTab(0);
            }
        } catch (error) {
            console.error("Error fetching products:", error);
            setProducts([]);
            setSelectedTab(0);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <CustomNavbar />
            <div className="productsdetails flex flex-col p-2">
                <Helmet>
                    <title>Our Product Categories | SEA</title>
                    <meta name="description" content="Explore a wide range of solar pump controllers." />
                    <meta name="keywords" content="Solar Pump, Controllers, Hybrid Pumps" />
                    <meta property="og:title" content="Explore Our Product Categories" />
                    <meta property="og:image" content="" />
                    <meta property="og:url" content="https://seaiot.in/products" />
                    <meta property="og:type" content="website" />
                </Helmet>

                <div className="background-textpd">Product Details</div>

                <div className="flex w-full flex-col justify-center">
                    {loading ? (
                        <div className="flex justify-center items-center h-48">
                            <Spinner color="warning" label="Loading Products..." />
                        </div>
                    ) : products.length === 0 ? (
                        <p className="text-center mt-5">No products found.</p>
                    ) : (
                        <Tabs selectedIndex={selectedTab} onChange={setSelectedTab}>
                            {products.map((product) => (
                                <Tab key={product.product_item_id} title={product.product_name || "Unnamed Product"}>
                                    <div className="flex justify-center text-xxl onehpheading">
                                        <h3>{product.product_description || "No description available"}</h3>
                                    </div>

                                    <div className="mt-10 detailstable">
                                        <div>
                                            {product.img_url ? (
                                                <>
                                                    {console.log("Image URL:", `${BASEURL}${product.img_url}`)}
                                                    <img
                                                        src={product.img_url.startsWith("http") ? product.img_url : `${BASEURL}${product.img_url}`}
                                                        className="Pumps"
                                                        alt={product.product_name}
                                                        style={{
                                                            filter: "drop-shadow(5px 5px 10px rgba(0, 0, 0, 0.5))",
                                                            borderRadius: "8px",
                                                            height: '450px',
                                                            position: 'relative',
                                                            zIndex: 5,
                                                        }}
                                                    />
                                                </>
                                            ) : (
                                                <p className="text-center">No Image Available</p>
                                            )}

                                        </div>

                                        <div className="grid grid-cols-12 p-2 m-2 justify-content-center detailstablegrid">
                                            <div className="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-6">
                                                <RevealBlurFX>
                                                    {product.additional_fields && Object.keys(product.additional_fields).length > 0 ? (
                                                        <table className="table-auto w-full border-collapse border border-gray-300">
                                                            <tbody>
                                                                {Object.entries(product.additional_fields).map(([key, value]) => (
                                                                    <tr key={key}>
                                                                        <td className="border border-gray-300 px-4 py-2 font-bold">{key}</td>
                                                                        <td className="border border-gray-300 px-4 py-2">{value}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    ) : (
                                                        <p className="text-center">No additional details available</p>
                                                    )}
                                                </RevealBlurFX>
                                            </div>
                                        </div>
                                    </div>
                                </Tab>
                            ))}
                        </Tabs>
                    )}
                </div>
                <Footer />
            </div>
        </>
    );
}

export default SearchDetails;
